import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
export { Api, PlasmicModulesFetcher } from '@plasmicapp/loader-fetcher';

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DepsGraph = /*#__PURE__*/function () {
  function DepsGraph(bundle, browserBuild) {
    if (browserBuild === void 0) {
      browserBuild = true;
    }

    this.bundle = bundle;
    this.browserBuild = browserBuild;
    this.dependsOn = {};
    this.dependedBy = {};
    this.rebuildGraph();
  }

  var _proto = DepsGraph.prototype;

  _proto.getTransitiveDependers = function getTransitiveDependers(name) {
    return this.transitiveCrawl(name, this.dependedBy);
  };

  _proto.getTransitiveDeps = function getTransitiveDeps(name) {
    if (!(name in this.dependsOn)) {
      return [];
    }

    return this.transitiveCrawl(name, this.dependsOn);
  };

  _proto.transitiveCrawl = function transitiveCrawl(name, edges) {
    var deps = new Set();

    var crawl = function crawl(dep) {
      if (deps.has(dep)) {
        return;
      }

      deps.add(dep);

      for (var _iterator = _createForOfIteratorHelperLoose((_edges$dep = edges[dep]) != null ? _edges$dep : []), _step; !(_step = _iterator()).done;) {
        var _edges$dep;

        var subdep = _step.value;
        crawl(subdep);
      }
    };

    for (var _iterator2 = _createForOfIteratorHelperLoose(edges[name]), _step2; !(_step2 = _iterator2()).done;) {
      var dep = _step2.value;
      crawl(dep);
    }

    return Array.from(deps);
  };

  _proto.rebuildGraph = function rebuildGraph() {
    this.dependedBy = {};
    this.dependsOn = {};

    for (var _iterator3 = _createForOfIteratorHelperLoose(this.browserBuild ? this.bundle.modules.browser : this.bundle.modules.server), _step3; !(_step3 = _iterator3()).done;) {
      var mod = _step3.value;

      if (mod.type === 'code') {
        for (var _iterator4 = _createForOfIteratorHelperLoose(mod.imports), _step4; !(_step4 = _iterator4()).done;) {
          var imported = _step4.value;

          if (!(mod.fileName in this.dependsOn)) {
            this.dependsOn[mod.fileName] = [imported];
          } else {
            this.dependsOn[mod.fileName].push(imported);
          }

          if (!(imported in this.dependedBy)) {
            this.dependedBy[imported] = [mod.fileName];
          } else {
            this.dependedBy[imported].push(mod.fileName);
          }
        }
      }
    }
  };

  return DepsGraph;
}(); // from `names`.


function getBundleSubset(bundle) {
  for (var _len = arguments.length, names = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    names[_key - 1] = arguments[_key];
  }

  var namesSet = new Set(names);
  var graph = new DepsGraph(bundle);
  var deps = new Set(names.flatMap(function (name) {
    return graph.getTransitiveDeps(name);
  }));

  var isSubModule = function isSubModule(fileName) {
    return deps.has(fileName) || namesSet.has(fileName);
  };

  return {
    modules: {
      browser: bundle.modules.browser.filter(function (mod) {
        return isSubModule(mod.fileName);
      }),
      server: []
    },
    external: bundle.external.filter(function (dep) {
      return deps.has(dep);
    }),
    components: bundle.components.filter(function (c) {
      return isSubModule(c.entry);
    }),
    globalGroups: bundle.globalGroups,
    projects: bundle.projects,
    activeSplits: bundle.activeSplits
  };
}

var isBrowser = typeof window !== 'undefined' && window != null && typeof window.document !== 'undefined';

var Registry = /*#__PURE__*/function () {
  function Registry() {
    this.loadedModules = {};
    this.registeredModules = {};
    this.modules = {};
  }

  Registry.getInstance = function getInstance() {
    if (!Registry.instance) {
      Registry.instance = new Registry();
    }

    return Registry.instance;
  };

  var _proto = Registry.prototype;

  _proto.register = function register(name, module) {
    this.registeredModules[name] = module;
  };

  _proto.isEmpty = function isEmpty() {
    return Object.keys(this.loadedModules).length === 0;
  };

  _proto.clear = function clear() {
    this.loadedModules = {};
  };

  _proto.getRegisteredModule = function getRegisteredModule(name) {
    return this.registeredModules[name];
  };

  _proto.hasModule = function hasModule(name, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (name in this.registeredModules && !opts.forceOriginal) {
      return true;
    }

    return name in this.modules;
  };

  _proto.load = function load(name, opts) {
    var _this = this;

    if (opts === void 0) {
      opts = {};
    }

    if (name in this.registeredModules && !opts.forceOriginal) {
      return this.registeredModules[name];
    }

    if (name in this.loadedModules) {
      return this.loadedModules[name];
    }

    if (!(name in this.modules)) {
      throw new Error("Unknown module " + name);
    }

    var code = this.modules[name];
    var requireFn = isBrowser ? function (dep) {
      var normalizedDep = resolvePath(dep, name);
      return _this.load(normalizedDep);
    } : function (dep) {
      try {
        var normalizedDep = resolvePath(dep, name);
        return _this.load(normalizedDep);
      } catch (err) {
        try {
          // Might be a nodeJs module such as tty
          return eval('require')(dep);
        } catch (_unused) {
          throw err;
        }
      }
    };
    var func = new Function('require', 'exports', code);
    var exports = {};
    this.loadedModules[name] = exports;
    func(requireFn, exports);
    return exports;
  };

  _proto.updateModules = function updateModules(bundle) {
    var updated = false;

    for (var _iterator = _createForOfIteratorHelperLoose(isBrowser ? bundle.modules.browser : bundle.modules.server), _step; !(_step = _iterator()).done;) {
      var mod = _step.value;

      if (mod.type === 'code' && mod.code !== this.modules[mod.fileName]) {
        this.modules[mod.fileName] = mod.code;
        updated = true;
      }
    }

    if (updated) {
      // TODO: do something more efficient than tearing everything down?
      this.clear();
    }
  };

  return Registry;
}(); // Singleton


Registry.instance = undefined;

function resolvePath(path, from) {
  var fromParts = from.split('/');
  var pathParts = path.split('/');

  if (pathParts.length === 0) {
    return path;
  }

  if (pathParts[0] === '.') {
    return [].concat(fromParts.slice(0, fromParts.length - 1), pathParts.slice(1)).join('/');
  } else if (pathParts[0] === '..') {
    var count = 0;

    for (var _iterator2 = _createForOfIteratorHelperLoose(pathParts), _step2; !(_step2 = _iterator2()).done;) {
      var part = _step2.value;

      if (part === '..') {
        count += 1;
      } else {
        break;
      }
    }

    return [].concat(fromParts.slice(0, fromParts.length - count - 1), pathParts.slice(count)).join('/');
  } else {
    return path;
  }
}

export { Registry, getBundleSubset };